import {
    CreateHolidayPayload,
    CreateHolidayResponse,
    DeleteHolidayPayload,
    DeleteHolidayResponse,
    ecsApi,
    GetHolidaysResponse,
    GetHolidayTypesResponse,
    UpdateHolidayPayload,
    UpdateHolidayResponse
} from '@services';

export const holidaysApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getHolidays: builder.mutation<GetHolidaysResponse, undefined>({
            query: () => ({
                url: '/holidays',
                method: 'GET'
            })
        }),
        getHolidayTypes: builder.mutation<GetHolidayTypesResponse, undefined>({
            query: () => ({
                url: '/holidays_types',
                method: 'GET'
            })
        }),
        createHoliday: builder.mutation<CreateHolidayResponse, CreateHolidayPayload>({
            query: (holiday) => ({
                url: '/holidays',
                method: 'POST',
                body: holiday
            })
        }),
        updateHoliday: builder.mutation<UpdateHolidayResponse, UpdateHolidayPayload>({
            query: (holiday) => ({
                url: '/holidays',
                method: 'PUT',
                body: holiday
            })
        }),
        deleteHoliday: builder.mutation<DeleteHolidayResponse, DeleteHolidayPayload>({
            query: (holiday) => ({
                url: '/holidays',
                method: 'DELETE',
                body: holiday
            })
        })
    })
});

export const {
    useGetHolidaysMutation,
    useCreateHolidayMutation,
    useGetHolidayTypesMutation,
    useUpdateHolidayMutation,
    useDeleteHolidayMutation
} = holidaysApi;
